<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_38_2)">
      <path
        d="M14.8571 2.57146L9.71429 0.857178L5.14286 2.57146L0 0.857178V10.5715L5.14286 12.2857L7.46857 11.4137C7.74229 13.5172 9.536 15.1429 11.7143 15.1429C14.0817 15.1429 16 13.2246 16 10.8572C16 9.73375 15.564 8.71432 14.8571 7.95032V2.57146ZM4.57143 11.4926L0.571429 10.1595V1.64975L4.57143 2.98346V11.4926ZM14.2857 2.98346V7.43432C13.5691 6.89489 12.6806 6.57146 11.7143 6.57146C11.2126 6.57146 10.7331 6.66175 10.2857 6.82061V1.65032L14.2857 2.98346ZM5.14286 3.17375L5.15371 3.17775L9.71429 1.46746V7.06803C8.36686 7.78061 7.44514 9.19032 7.43086 10.8177L5.14286 11.6755V3.17375ZM15.4286 10.8572C15.4286 12.9086 13.7657 14.5715 11.7143 14.5715C9.66286 14.5715 8 12.9086 8 10.8572C8 8.80575 9.66286 7.14289 11.7143 7.14289C13.7657 7.14289 15.4286 8.80575 15.4286 10.8572Z"
        fill="white"
      />
      <path
        d="M12 11.1428H14.2857V10.5714H12V8.28564H11.4285V10.5714H9.14282V11.1428H11.4285V13.4285H12V11.1428Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_38_2">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
